import { BurgerBtnProps } from './BurgerBtn.types'

import './BurgerBtn.scss'

const BurgerBtn: React.FC<BurgerBtnProps> = ({ isOpened, onClick }): JSX.Element => {
	return (
		<button className={`burgerBtn burgerBtn--${isOpened ? 'opened' : 'closed'}`} onClick={onClick}>
			<div className={`burgerBtn__inner burgerBtn__inner--${isOpened ? 'opened' : 'closed'}`}></div>
		</button>
	)
}

export default BurgerBtn
